import React, { FC } from 'react'
import { NonFlexingContainer } from '@sport1/news-styleguide'
import { useContentSizeListner } from './providers/ParentFrameProvider/hooks/withTrackWindowSize'

const AppStyle: FC = ({ children }) => {
    useContentSizeListner()

    return <NonFlexingContainer backgroundColor="pearl">{children}</NonFlexingContainer>
}

export default AppStyle
